import React, {ReactNode} from "react";
import DomHelper from "../../helper/DomHelper";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class RejectedStamp extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let id: string = "gradient-" + DomHelper.generateUUID();

		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox={"0 0 100 100"}>
				<g style={{
					opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
					transformOrigin: "50% 50%"
				}}>
					<defs>
						<linearGradient id={id} x1={0} x2="100%" y1={0} y2="100%">
							<stop offset={0} style={{stopOpacity: 1, stopColor: "#F79B8A"}}/>
							<stop offset="100%" style={{stopOpacity: 1, stopColor: "#C1443F"}}/>
						</linearGradient>
					</defs>
					{FunctionHelper.exists(this.props.onMoveStart) &&
						<polygon
							points="0,15 15,0 50,37.5 85,0 100,15 62.5,50 100,85 85,100 50,62.5 15,100 0,85 37.5,50"
                            onClick={this.props.onClick} onContextMenu={this.props.onContextMenu}
							className="movearea" onPointerDown={this.props.onMoveStart}/>
					}
					<polygon
						points="0,15 15,0 50,37.5 85,0 100,15 62.5,50 100,85 85,100 50,62.5 15,100 0,85 37.5,50"
						style={{
							fill: "#F79B8A",
							strokeWidth: 5,
							stroke: "#A33530"
						}}/>
				</g>
			</svg>
		);
	}
}